import styles from "./Checkbox.module.scss"

const Checkbox = ({ id = '' ,checked, onChange, name }) => {
  return (
    <label className={styles["outer-box"]}>
      <input type="checkbox" checked={checked} onChange={onChange} name={name} id={id} />
      <span className={styles["tick"]}></span>
    </label>
  )
}

export default Checkbox
